module.exports = __webpack_public_path__ + "img/popcorn.8a94486a.png";